import { useSite } from "../context/SiteContext";
import React, { useState } from "react";
import { MessageCircle, Phone, Calendar, MapPin, X, ChevronRight, HelpCircle } from "lucide-react";

export default function FloatingWhatsApp({ onBookDoctor, onInquireTest }) {
  const { settings: site } = useSite();
  const [isOpen, setIsOpen] = useState(false);
  if (site && site.floating_whatsapp && site.floating_whatsapp.visible === false) return null;

  const handleAction = (text) => {
    const encoded = encodeURIComponent(`Hello 6SigmaCare Kolkata Team, I would like to inquire about: ${text}`);
    window.open(`https://wa.me/${((site && site.whatsapp_number) || "+919674292244").replace(/\D/g, "")}?text=${encoded}`, "_blank");
    setIsOpen(false);
  };

  return (
    <div className="fixed bottom-20 sm:bottom-6 right-4 sm:right-6 z-40 no-print">
      {isOpen && (
        <div 
          data-testid="whatsapp-chat-popup"
          className="mb-3 w-80 bg-white rounded-2xl shadow-2xl border border-gray-100 overflow-hidden animate-in fade-in slide-in-from-bottom-4"
        >
          {/* Header */}
          <div className="bg-[#0D3B2E] text-white p-4 flex items-center justify-between">
            <div className="flex items-center gap-3">
              <div className="w-9 h-9 rounded-full bg-emerald-700 flex items-center justify-center text-amber-300">
                <MessageCircle className="w-5 h-5" />
              </div>
              <div>
                <h4 className="text-sm font-bold text-white">6SigmaCare Care Desk</h4>
                <p className="text-[11px] text-emerald-200 flex items-center gap-1">
                  <span className="w-2 h-2 rounded-full bg-emerald-400 animate-pulse"></span>
                  Online • Salt Lake Centre
                </p>
              </div>
            </div>
            <button 
              onClick={() => setIsOpen(false)} 
              data-testid="whatsapp-close-btn"
              className="text-gray-300 hover:text-white"
            >
              <X className="w-5 h-5" />
            </button>
          </div>

          {/* Body Options */}
          <div className="p-4 bg-[#FBF9F4] space-y-2 text-xs">
            <p className="text-gray-600 mb-3 leading-relaxed">
              Welcome to 6SigmaCare Polyclinic & Advanced Diagnostics Kolkata. How can our team assist you today?
            </p>

            <button
              onClick={() => handleAction("Booking Specialist Doctor OPD Appointment")}
              data-testid="whatsapp-opt-book-doctor"
              className="w-full flex items-center justify-between p-2.5 bg-white hover:bg-emerald-50 rounded-xl border border-gray-200 text-left text-gray-800 font-medium transition-all"
            >
              <span className="flex items-center gap-2">
                <Calendar className="w-4 h-4 text-[#3B8271]" />
                Book Doctor OPD Appointment
              </span>
              <ChevronRight className="w-4 h-4 text-gray-400" />
            </button>

            <button
              onClick={() => handleAction("Diagnostic Test / Blood Test / USG / X-Ray / Echo Inquiry")}
              data-testid="whatsapp-opt-inquire-test"
              className="w-full flex items-center justify-between p-2.5 bg-white hover:bg-emerald-50 rounded-xl border border-gray-200 text-left text-gray-800 font-medium transition-all"
            >
              <span className="flex items-center gap-2">
                <HelpCircle className="w-4 h-4 text-[#3B8271]" />
                Ask About Tests & Preparation
              </span>
              <ChevronRight className="w-4 h-4 text-gray-400" />
            </button>

            <button
              onClick={() => handleAction("Home Sample Collection Booking in Kolkata")}
              data-testid="whatsapp-opt-home-collection"
              className="w-full flex items-center justify-between p-2.5 bg-white hover:bg-emerald-50 rounded-xl border border-gray-200 text-left text-gray-800 font-medium transition-all"
            >
              <span className="flex items-center gap-2">
                <Phone className="w-4 h-4 text-[#3B8271]" />
                Home Sample Collection
              </span>
              <ChevronRight className="w-4 h-4 text-gray-400" />
            </button>

            <button
              onClick={() => handleAction("Centre Location, Parking & Route Directions")}
              data-testid="whatsapp-opt-directions"
              className="w-full flex items-center justify-between p-2.5 bg-white hover:bg-emerald-50 rounded-xl border border-gray-200 text-left text-gray-800 font-medium transition-all"
            >
              <span className="flex items-center gap-2">
                <MapPin className="w-4 h-4 text-[#3B8271]" />
                Centre Directions & Parking
              </span>
              <ChevronRight className="w-4 h-4 text-gray-400" />
            </button>
          </div>

          <div className="p-2.5 bg-emerald-950 text-[10px] text-emerald-300 text-center">
            🔒 Medical records are managed securely via your My Health portal.
          </div>
        </div>
      )}

      {/* Floating Trigger Button */}
      <button
        onClick={() => setIsOpen(!isOpen)}
        type="button" data-testid="whatsapp-floating-button"
        className="flex items-center gap-2 bg-[#25D366] hover:bg-[#20bd5a] text-white px-4 py-3 rounded-full shadow-2xl transition-transform hover:scale-105 group font-medium text-xs border-2 border-white"
        title="Chat on WhatsApp"
      >
        <MessageCircle className="w-5 h-5 fill-white text-white" />
        <span className="hidden sm:inline font-semibold">{(site && site.floating_whatsapp && site.floating_whatsapp.label) || "Talk to Reception"}</span>
      </button>
    </div>
  );
}
